import axios from "axios";
import { useEffect, useState } from "react";
import { HEADERS_API } from "../NuevaGuia";
import { ValidarLtr, ValidarNum, ValidarNumLtr } from "../../shared/Regex";

export default function FormularioConductor({funcionAgregar, funcionCancelar, listaDocumentos}){
    //#region HOOKS STATE
    // =========================================================================================
    
    const[tipoDoc, setTipoDoc] = useState("1");
    const[nroDoc, setNroDoc] = useState("");
    const[nombre, setNombre] = useState("");
    const[licencia, setLicencia] = useState("");

    // Estados de validación
    const[datosCompletos, setDatosCompletos] = useState(true);
    //#endregion

    //#region HOOKS EFFECT
    // =========================================================================================
    useEffect(()=>{
        try{
            if(tipoDoc == "" || tipoDoc =="6" || nroDoc == "" || nombre == "" || licencia == ""){
                throw new Error();
            }
            HandlerDatosCompletos(false);
        }catch(error){
            HandlerDatosCompletos(true);
        }
    },[tipoDoc, nroDoc, nombre, licencia]);
    //#endregion

    //#region  HANDLERS
    // =========================================================================================
    const HandlerTipoDoc = (codigo) => setTipoDoc(codigo);

    const HandlerNroDoc = (valor) => {
        if(ValidarNum(valor) || valor == ""){
            setNroDoc(valor);
        }
    }
    const HandlerNombre = (valor) => {
        if(ValidarLtr(valor) || valor == ""){
            setNombre(valor.toUpperCase());
        }
    }
    const HandlerLicencia = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setLicencia(valor.toUpperCase());
        }
    }
    const HandlerDatosCompletos = (valor) => {
        setDatosCompletos(valor);
    }
    //#endregion

    //#region FUNCIONES
    // =========================================================================================

    // FUNCIONES ASÍNCRONAS
    const registrarConductor = async () => {
        try{
            let response = await axios.post(URL_INSERTAR_CONDUCTOR,{
                codigoUsuario: "",
                tipoDoc: tipoDoc,
                nroDoc: nroDoc,
                nombre: nombre,
                licencia: licencia
            },{
                headers:HEADERS_API
            }).catch(error=>{
                throw new Error(error.message);
            });
            // console.log(response.data);
        }catch(error){
            console.log(error);
        }
    }

    const ejecutarFuncion = async () => {
        funcionAgregar(nombre, tipoDoc, nroDoc, licencia);
        await registrarConductor();
        funcionCancelar();        
    }
    //#endregion

    //#region CONTENIDO
    // =========================================================================================
    return (
    <div id="modal-actor" className="d-flex justify-content-center align-items-center">
        <div id="formulario-registro">
            <div className="bg-primary text-white p-2 fs-4">
                NUEVO CONDUCTOR
            </div>
            <div className=" p-2">
                <div className="row">
                    <div className="pb-3 col-12">
                        <label htmlFor="nombre-conductor" className="col-form-label fw-semibold">Nombres y Apellidos</label>
                        <input onChange={e => HandlerNombre(e.target.value)} value={nombre} maxLength={120} id="nombre-conductor" type="text" className="form-control" autoComplete="off" />                        
                    </div>
                    <div className="pb-3 col-12">
                        <label htmlFor="tipo-doc" className="col-form-label fw-semibold">Documento de Identidad</label>
                        <select onChange={e => HandlerTipoDoc(e.target.value)} value={tipoDoc} id="tipo-doc" type="select" className="form-select f-actor-texto" >
                            {listaDocumentos}                          
                        </select>
                        <small className="text-danger">Se admiten todos los documentos menos RUC</small>
                    </div>
                    <div className="pb-3 col-12">
                        <label htmlFor="nro-doc" className="col-form-label fw-semibold">N° Documento de Identidad</label>
                        <input onChange={e => HandlerNroDoc(e.target.value)} value={nroDoc} maxLength={8} id="nro-doc" type="text" className="form-control" autoComplete="off" />                        
                    </div>
                    <div className="pb-3 col-12">
                        <label htmlFor="licencia-conductor" className="col-form-label fw-semibold">N° Licencia de conducir</label>
                        <input onChange={e => HandlerLicencia(e.target.value)} value={licencia} maxLength={20} id="licencia-conductor" type="text" className="form-control" autoComplete="off" />                        
                    </div>
                    <div className="p-2 d-flex justify-content-around">
                        <button onClick={funcionCancelar} className="btn btn-secondary">Cancelar</button>
                        <button onClick={ejecutarFuncion} disabled={datosCompletos} className="btn btn-primary">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
    //#endregion
}
//#region CONSTANTES
const URL_INSERTAR_CONDUCTOR = process.env.REACT_APP_URL_INSERTAR_CONDUCTOR;
//#endregion